"use client";
import React, { useState } from "react";
import { Autocomplete, useLoadScript, Libraries } from "@react-google-maps/api";
import { Input } from "../atoms/input";
import { Spinner } from "../atoms/spinner";

interface AddressInputProps {
  onSelectAddress: (address: string) => void;
  defaultValue?: string;
}

const libraries: Libraries = ["places"];

export const AddressInput: React.FC<AddressInputProps> = ({
  onSelectAddress,
  defaultValue,
}) => {
  const [autocomplete, setAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const [inputValue, setInputValue] = useState<string>(defaultValue || "");

  const onPlaceSelected = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place && place.formatted_address) {
        const address = place.formatted_address;
        setInputValue(address);
        onSelectAddress(address);
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    if (value.trim() === "") {
      onSelectAddress("");
    }
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: `${process.env.NEXT_PUBLIC_GOOGLE_API_KEY}`,
    libraries,
  });

  if (!isLoaded) {
    return <Spinner />;
  }

  return (
    <Autocomplete
      onLoad={(autoComp) => setAutocomplete(autoComp)}
      onPlaceChanged={onPlaceSelected}>
      <Input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Enter address"
        className="w-full mt-1"
      />
    </Autocomplete>
  );
};
